import type { Command } from "../models/commands.ts";
import type { CommandRejectedReason } from "../models/events.ts";
import type { WorldState } from "../models/worldState.ts";
import type { ReduceResult } from "./result.ts";

export function rejectCommand(
  state: WorldState,
  command: Command,
  reason: CommandRejectedReason,
): ReduceResult {
  return {
    state,
    events: [{ type: "CommandRejected", command, reason }],
  };
}
